import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-checkbox/es/index.js
// module id = 239
// module chunks = 0 1